import React from 'react';
import { Card, CardContent } from '@material-ui/core';
import Hidden from '@material-ui/core/Hidden/Hidden';
import { makeStyles } from '@material-ui/core/styles';
import { ArticleSkeleton } from 'common/ui/skeleton-ui';
import SectionTab from 'constants/SectionTab';
import { ItemList } from 'modules2/components';
import container from './GenresCard.container';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 345,
    background: theme.palette.paperColor,
    color: theme.palette.textColor,
  },
  listContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    marginTop: 10,
  },
    empty: {
    fontFamily: theme.typography.fontFamily,
      paddingBottom: theme.spacing(1),
  },
}));

const GenresCard = (props) => {
  const classes = useStyles();
  const {
    radioState,
    genresList,
    onSetCurrentTab,
    onSetGenres,
    onFetchGenresRadioListStart,
  } = props;

  const onListItemClick = (tab, genresId) => {
    onSetCurrentTab(tab);
    onSetGenres(genresId);
    onFetchGenresRadioListStart(radioState.currentCountryCode, genresId);
  };

  const displayLocationList = (loading, num) => {
    if (loading) {
      return [...Array(num)].map((_, idx) => {
        return <ArticleSkeleton key={idx} />;
      });
    }

    return genresList.length === 0 ?
      (
        <div className={classes.empty}>
          Genres not available.
        </div>
      ) :
      (
        genresList.map((value, ind) => {
          return (
            <ItemList
              key={ind}
              id={value.id}
              name={value.name}
              sectionTab={SectionTab.GenreStation}
              onListItemClick={onListItemClick}
            />
          );
        })
      )
  };

  return (
    <Card className={classes.root}>
      <CardContent style={{ padding: 0 }}>
        <Hidden smDown>
          <div className={classes.listContainer}>
            {displayLocationList(false, 3)}
          </div>
        </Hidden>
        <Hidden mdUp>
          <div className={classes.listContainer}>
            {displayLocationList(false, 1)}
          </div>
        </Hidden>
      </CardContent>
    </Card>
  );
};

export default container(GenresCard);
